export class NoWebglScreen {
    public static show() {
        $('#no_flash_screen').show();
    }
}
